import { FunctionComponent } from 'react';
import { ITuple3 } from '../component-data-structure';

interface IParentProps {
	occlusion?: boolean;
	rotation?: ITuple3;
	position?: ITuple3;
	occlusionPlanePosition?: ITuple3;
	shadowPlanePosition?: ITuple3;
	opacity?: number;
}

const ShadowPlane: FunctionComponent<IParentProps> = ({ occlusion = false, rotation, position, opacity = 0.15, shadowPlanePosition, occlusionPlanePosition }) => {
	return (
		<group name={'shadow-plane-group'} rotation={rotation} position={position}>
			<mesh receiveShadow position={shadowPlanePosition}>
				<planeGeometry args={[1000, 1000]} />
				{/* <meshBasicMaterial color={new Color('red')} /> */}
				<shadowMaterial
					opacity={opacity}
					depthWrite={false}
					polygonOffset
					polygonOffsetFactor={-10} // positive value pushes polygon further away
					polygonOffsetUnits={10}
				/>
			</mesh>
			{occlusion && <mesh position={occlusionPlanePosition}>
				<planeGeometry args={[1000, 1000]} />
				<meshBasicMaterial
					colorWrite={false}
					depthWrite={true}
					polygonOffset
					polygonOffsetFactor={20} // positive value pushes polygon further away
					polygonOffsetUnits={20}
				/>
			</mesh>}
		</group>
	);
};

export default ShadowPlane;
